exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pos-print[data-v-07371dad]{width:400px}@media print{.pos-print[data-v-07371dad]{width:100%}}", ""]);

// exports
